import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { DATA_LAKE_API_ROUTES, DATA_LAKE_CONFIG_QUERY_KEYS } from "data-lake/Constants";
const fetchDataLakeBackend = (id) => fetch("GET", qualifyUrl(`${DATA_LAKE_API_ROUTES.DataLakeAPIController.backend.get(id).url}`));
const useDataLakeBackend = (id, enabled = true) => {
  const { data, refetch, isInitialLoading, isSuccess, error } = useQuery({
    queryKey: [...DATA_LAKE_CONFIG_QUERY_KEYS, id],
    queryFn: () => fetchDataLakeBackend(id),
    placeholderData: keepPreviousData,
    enabled
  });
  return {
    data,
    refetch,
    isInitialLoading,
    isSuccess,
    error
  };
};
export default useDataLakeBackend;
